import React from 'react';
import CountUp from 'react-countup';

function MetricCardIndustry({ bgColor = 'bg-light-blue', title, description, titleColor = 'content-primary', descriptionColor = 'content-secondary', titleClass = '' }) {
  const numericValue = parseInt(title);
  const suffix = title.replace(/[0-9]/g, '');

  return (
    <div className={`lg:w-[252px] h-[135px] p-6 gap-2 rounded-lg lg:my-0 my-3 ${bgColor}`}>
      <div className={`display-small ${titleClass} ${titleColor}`}>
        {!isNaN(numericValue) ? (
          <CountUp
            end={numericValue}
            duration={3}
            suffix={suffix}
            className={`display-small ${titleColor}`}
            key={'visible'}
          />
        ) : (
          title
        )}
      </div>
      <div className={`label-medium ${descriptionColor}`}>{description}</div>
    </div>
  );
}

export default MetricCardIndustry;
